import 'regenerator-runtime/runtime';
import 'flowbite';

Drupal.behaviors.flowbite = {
  isStarted: false,
  attach() {
    if (Drupal.behaviors.flowbite.isStarted === false) {
      initFlowbite();
      Drupal.behaviors.flowbite.isStarted = true;
    }
  },
};
